var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    transform: "translate(-613.042 -1130.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_24",
    "data-name": "Elipse 24",
    transform: "translate(613.042 1130.627)",
    fill: "none",
    stroke: "#f2bcbd",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(629.011 1145.133)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_42",
    "data-name": "L\\xEDnea 42",
    x2: 7.999,
    y2: 8.799,
    transform: "translate(0 11.273)",
    fill: "none",
    stroke: "#f2bcbd",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_43",
    "data-name": "L\\xEDnea 43",
    x1: 8.91,
    y2: 20.072,
    transform: "translate(7.999 0)",
    fill: "none",
    stroke: "#f2bcbd",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTic);
export default __webpack_public_path__ + "static/media/tic.5c9b01e933fb31734c126d3103f79245.svg";
export { ForwardRef as ReactComponent };